module.exports = __webpack_public_path__ + "static/media/baseMeme17thumb.681503a5.jpg";